export default __webpack_public_path__ + "static/media/gallery_e-min.c8041a3b.jpg";